// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__djRxV","table":"Table_table__Agnum","state":"Table_state__3894c"};